var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-item transaction shadowless" }, [
    _c(
      "div",
      {
        staticClass: "entity-main-data",
        attrs: { id: "process-result-item", "data-cy": "process-result-item" },
      },
      [
        _c(
          "div",
          {
            staticClass: "movement-type field is-grouped item",
            attrs: {
              id: `item-tag-${_vm.pos}`,
              "data-cy": `item-tag-${_vm.pos}`,
            },
          },
          [
            _vm.appraisal.processingStatus == "SAVED"
              ? _c(
                  "span",
                  {
                    staticClass: "tag is-medium is-success is-light",
                    attrs: { id: "appraisal-saved-tag" },
                  },
                  [_vm._v(" Creado ")]
                )
              : _vm._e(),
            _vm.appraisal.processingStatus == "PROCESSED"
              ? _c(
                  "span",
                  {
                    staticClass: "tag is-medium is-success is-light",
                    attrs: {
                      id: "appraisal-processed-tag",
                      "data-cy": "appraisal-processed-tag",
                    },
                  },
                  [_vm._v(" Procesado ")]
                )
              : _vm._e(),
            _vm.appraisal.processingStatus == "TO_AMEND"
              ? _c(
                  "div",
                  { staticClass: "tag-and-counter" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "tag is-medium is-warning is-light",
                        attrs: {
                          id: "appraisal-toamend-tag",
                          "data-cy": "appraisal-toamend-tag",
                        },
                      },
                      [_vm._v(" Por Enmendar ")]
                    ),
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-tag",
                          { attrs: { rounded: "", type: "is-warning" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.appraisal.processingTransactionsResult
                                  .transactionsToAmend.length
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "title" }, [_vm._v(" Cliente ")]),
          _c("span", [_vm._v(_vm._s(_vm.appraisal.investorName))]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "title" }, [_vm._v("Fecha endoso")]),
          _c("span", [_vm._v(_vm._s(_vm.appraisal.salesDate))]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "title" }, [_vm._v("Tipo")]),
          _c("span", [_vm._v(_vm._s(_vm.appraisal.salesType))]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "title" }, [_vm._v("Nro. Operaciones")]),
          _c("span", [_vm._v(_vm._s(_vm.appraisal.totalOperations))]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "title" }, [_vm._v("Fecha de creación")]),
          _c("span", [_vm._v(_vm._s(_vm.appraisal.createdAt.split("T")[0]))]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "title" }, [_vm._v("Valor")]),
          _c("span", [
            _vm._v(
              "UF " + _vm._s(_vm.formatNumber(_vm.appraisal.totalAmountAwarded))
            ),
          ]),
        ]),
        _c("div", { staticClass: "extend-button" }, [
          _vm.appraisal.processingStatus == "TO_AMEND"
            ? _c(
                "a",
                {
                  staticClass: "text-not-underline",
                  attrs: {
                    id: `extend-button-${_vm.pos}`,
                    "data-cy": `extend-button-${_vm.pos}`,
                    href: "#",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.showDetails(_vm.pos)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", {
                      staticClass: "fas fa-chevron-up transition-slow",
                      class: { rotate: _vm.extendedEntity !== _vm.pos },
                    }),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "entity-detailed-data content transition-slow",
        class: { show: _vm.extendedEntity === _vm.pos },
        attrs: {
          id: `extended-detail-${_vm.pos}`,
          "data-cy": `extended-detail-${_vm.pos}`,
        },
      },
      _vm._l(
        _vm.appraisal.processingTransactionsResult.transactionsToAmend,
        function (transaction, i) {
          return _c("appraisal-history-transaction-item", {
            key: `${transaction}-${i}`,
            staticClass: "entity-details",
            style: { "--i": i },
            attrs: {
              id: `item-${i}`,
              "appraisal-id": _vm.appraisal._id,
              transaction: transaction,
              pos: i,
            },
            on: {
              updateAppraisalStatus: _vm.updateAppraisalStatus,
              updateTransactionStatus: _vm.updateTransactionStatus,
            },
          })
        }
      ),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }